import { Box, Divider, Typography, styled } from '@mui/material';

export const ProjectItemContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: theme.spacing(10),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[700],
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2.5),
}));

export const ActionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.grey[600],
  height: theme.spacing(3),
}));

export const CreationDate = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[300],
}));
